import { createExposureContributorsQuery } from "./exposure"
import { createDrilldownContributorsQuery } from "./drilldown-helpers"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export function createDrilldownExposureContributorsQuery({
  selectedFactor,
  selectedCategory,
  ...options
}: ContributorsQueryOptions) {
  const categoryOptions = selectedCategory ? { ...options, category: selectedCategory } : options
  const factorIds = selectedFactor ? [selectedFactor] : []
  return createDrilldownContributorsQuery(createExposureContributorsQuery, factorIds, categoryOptions)
}

export function createExposureDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  selectedCategory,
  classifications,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & { selectedFactor?: string, selectedCategory?: string }) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    instrumentSuffix,
  })
  const exposureGatherer = createDrilldownExposureContributorsQuery({
    ...coreOptions,
    prefix: `exposure${instrumentSuffix}`,
    to: endDate,
    selectedFactor,
    selectedCategory,
  })
  return [...baseGatherers, exposureGatherer]
}
